<template>
  <v-dialog max-width="600" v-model="dialog" @keydown.enter.prevent="onenter">
    <v-card>
      <v-card-title>
        <span class="headline">Energy Refill ({{ this.rules.name }})</span>
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" md="12" sm="12">
            <v-text-field disabled label="UID:" v-model.trim="model.uid" hide-details outlined dense/>
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <v-text-field
              label="Name"
              v-model.trim="model.name"
              v-ascii-only
            />
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <v-text-field
              label="Key"
              v-model.trim="model.key"
              v-ascii-only
            />
          </v-col>
        </v-row>

        <v-expansion-panels class="mb-5">
          <r-guard-panel :model.sync="model.guard" title="Guard Config"/>
          <r-guard-money-panel :model.sync="model.guardMoney" title="Guard Money"/>
        </v-expansion-panels>

        <v-expansion-panels class="mb-5">
          <r-panel title="Settings">
            <v-row dense>
              <v-col cols="12" sm="6" md="6">
                <v-checkbox v-model="model.hasPopup" label="Comes with Popup" hide-details/>
              </v-col>
            </v-row>
            <v-row dense class="mt-3">
              <v-col cols="12" sm="6" md="6">
                <r-ad-placement-dropdown :model.sync="model.adUID" :clearable="true" label="Refill Ad Placement"/>
              </v-col>
            </v-row>
          </r-panel>
        </v-expansion-panels>

        <v-expansion-panels class="mb-5">
          <r-product-panel :items.sync="model.products" :kinds="kinds" title="Products"/>
        </v-expansion-panels>

      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>
          Cancel
        </v-btn>
        <v-btn @click="save" color="blue darken-1" text>
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import {ViewRules} from "@/common/ViewRules";
import {ProductGroupKind} from "@/modules/redactor/models/product/ProductGroupKind";
import {SmartOfferBundleEnergyRefill} from "../../../models/smart-offer/bundle-energy-refill/SmartOfferBundleEnergyRefill";

import RGuardPanel from "@/modules/redactor/views/guard/r-guard-panel.vue";
import RGuardMoneyPanel from "@/modules/redactor/views/guard/r-guard-money-panel.vue";
import RProductPanel from "@/modules/redactor/views/product/r-product-panel.vue";
import RAdPlacementDropdown from "@/modules/redactor/views/ad-settings/placement/r-ad-placement-dropdown.vue";
import RPanel from "@/modules/redactor/views/utils/r-panel.vue";

export default {
  name: "r-smart-offer-bundle-energy-refill",
  components: {RProductPanel, RGuardMoneyPanel, RGuardPanel, RAdPlacementDropdown, RPanel},
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    tab: null,
    model: new SmartOfferBundleEnergyRefill(),
    rules: ViewRules.READONLY,
  }),
  computed: {
    kinds() {
      if (!this.model) {
        return [];
      } else {
        return [ProductGroupKind.SMART_OFFERS];
      }
    }
  },
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.tab = null;
      this.rules = rules;
      this.model = model || new SmartOfferBundleEnergyRefill();

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    },
    onenter() {
      this.save();
    }
  }
}
</script>
